var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.rulesVolumes
        ? _c("sc-form", {
            attrs: { form: _vm.quoteFreightVolume, rules: _vm.rulesVolumes },
            on: { change: _vm.updateFields, submit: _vm.submit },
            scopedSlots: _vm._u([
              {
                key: "fields",
                fn: function(ref) {
                  var fields = ref.fields
                  return [
                    _c("sc-real-time-quotation"),
                    _vm._v(" "),
                    _c("sc-logistic-draft"),
                    _vm._v(" "),
                    _c("sc-basic-data", { attrs: { fields: fields } }),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("sc-volume", { attrs: { fields: fields } })
                  ]
                }
              },
              {
                key: "actions",
                fn: function(ref) {
                  var isValid = ref.isValid
                  return [
                    _c("sc-button", {
                      attrs: {
                        listContractFilter: "",
                        theme: "default",
                        text: "Voltar"
                      },
                      on: { click: _vm.backUrl }
                    }),
                    _vm._v(" "),
                    _c("sc-button", {
                      attrs: {
                        type: "submit",
                        theme: "primary",
                        text: "Calcular"
                      }
                    })
                  ]
                }
              }
            ])
          })
        : _vm._e(),
      _vm._v(" "),
      _c("sc-delivery-options", { attrs: { fields: _vm.newFields } }),
      _vm._v(" "),
      _c("sc-excluded-methods")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31bd71c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bd71c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-quote-freight-by-volume/ScQuoteFreightByVolume.vue
// module id = null
// module chunks = 